(() => {
  const initialize = (root) => {
    if (!root || root.dataset.optcgInitialized === 'true') return;
    root.dataset.optcgInitialized = 'true';
    root.classList.add('optcg--animate');

    const sunny = root.querySelector('[data-optcg-sunny]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (sunny) {
      let direction = 1;
      let position = -sunny.offsetWidth - 24;
      let previousTime = null;

      const sail = (time) => {
        const width = sunny.offsetWidth;
        const travel = window.innerWidth + (width + 24) * 2;
        const duration = window.innerWidth <= 620 ? 16000 : 20000;
        if (previousTime !== null) position += direction * (travel / duration) * Math.min(time - previousTime, 64);

        const minimum = -width - 24;
        const maximum = window.innerWidth + width + 24;
        if (direction > 0 && position > maximum) position = minimum;
        if (direction < 0 && position < minimum) position = maximum;

        sunny.style.transform = `translate3d(${position}px, 0, 0)`;
        previousTime = time;
        window.requestAnimationFrame(sail);
      };

      sunny.addEventListener('click', () => {
        direction *= -1;
        sunny.classList.remove('is-turning-left', 'is-turning-right');
        void sunny.offsetWidth;
        sunny.classList.toggle('is-reversed', direction < 0);
        sunny.classList.add(direction < 0 ? 'is-turning-left' : 'is-turning-right');
      });

      sunny.querySelector('.optcg__sunny-facing')?.addEventListener('animationend', (event) => {
        if (!event.animationName.startsWith('optcg-sunny-turn')) return;
        sunny.classList.remove('is-turning-left', 'is-turning-right');
      });

      if (!reducedMotion) window.requestAnimationFrame(sail);
    }

    const items = root.querySelectorAll('[data-optcg-reveal]');
    if (!('IntersectionObserver' in window) || reducedMotion) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -24px' });

    items.forEach((item) => observer.observe(item));
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-optcg]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
